var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconPaperPlaneRight = function SvgIconPaperPlaneRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.206 1.39a1.75 1.75 0 0 1 1.021.21l.005.003 15.83 8.866.003.001a1.75 1.75 0 0 1 0 3.06l-.003.001-15.835 8.87a1.75 1.75 0 0 1-2.494-2.122L5.685 12 2.733 3.722A1.753 1.753 0 0 1 4.206 1.39m.634 2.285L7.451 11h5.299a1 1 0 1 1 0 2H7.45l-2.61 7.325L19.702 12z",
    clipRule: "evenodd"
  })));
};
export default SvgIconPaperPlaneRight;